import { VideoCard } from 'ui/components';

export const VideoCardFeature: React.FC<Content.VideoCard> = ({ content }) => (
	<VideoCard {...content?.properties}  />
);
